import React from 'react'
import { wahoCard, wahoCardBg, whiteCard } from '../common/cssclasses'

export default function WahoConfernceCard({ title = "", time = "", paragraph = "" }) {
    return (
        <div className={wahoCard}>
            <div className={wahoCardBg}>
                <div className='horseCardTitle mb-form-group'>{title}</div>
                <div className="whiteSpacer mb-form-group"></div>
                <div className='horseCardDescription mb-1 fw-bold'>{time}</div>
                <div className='horseCardDescription'>{paragraph}</div>
            </div>
        </div>
    )
}
